import { lazy } from 'react';

const RELOAD_FLAG = 'chunk-reload-attempted';

// React.lazy() for route screens, with one automatic page reload if a screen's chunk
// fails to load. After a new deploy, a tab opened earlier may request chunk files that
// no longer exist; one reload fetches the new index.html and chunk names. The
// sessionStorage flag stops a genuine network failure from reloading forever.
export default function lazyWithRetry(factory) {
  return lazy(() =>
    factory()
      .then((module) => {
        try {
          sessionStorage.removeItem(RELOAD_FLAG);
        } catch (e) {
          // storage unavailable: nothing to clear
        }
        return module;
      })
      .catch((error) => {
        let alreadyReloaded = true;
        try {
          alreadyReloaded = sessionStorage.getItem(RELOAD_FLAG) === '1';
          if (!alreadyReloaded) {
            sessionStorage.setItem(RELOAD_FLAG, '1');
          }
        } catch (e) {
          // storage unavailable: do not risk a reload loop
        }
        if (!alreadyReloaded) {
          window.location.reload();
          return new Promise(() => {});
        }
        throw error;
      })
  );
}
